var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroShapeTopLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 587,
    height: 431,
    viewBox: "0 71 587 431",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M436.129 156.919C472.897 115.201 552.03 82.2572 587 71H0V383.388C25.3118 385.706 99.3154 382.693 192.836 352.099C309.736 313.858 390.168 209.067 436.129 156.919Z",
    fill: "url(#paint0_linear_2830_3990)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.071 171.151C69.0411 147.633 18.8445 94.5846 0 71V502C53.1983 493.862 171.702 452.074 220.131 350.029C280.667 222.473 181.608 200.549 119.071 171.151Z",
    fill: "url(#paint1_linear_2830_3990)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2830_3990",
    x1: 514.5,
    y1: 71,
    x2: -0.0000114239,
    y2: 250.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F0FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2830_3990",
    x1: 119.5,
    y1: 71,
    x2: 119.5,
    y2: 502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F8FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroShapeTopLeft);
export default __webpack_public_path__ + "static/media/hero-shape-top-left.886b60c1078d9a38de9578fd04c45eb8.svg";
export { ForwardRef as ReactComponent };